// extracted by mini-css-extract-plugin
export default {"customCheckbox":"customCheckbox_customCheckbox__ODfWB","ant-checkbox-wrapper-checked":"customCheckbox_ant-checkbox-wrapper-checked__0z4Nz"};